<template>
	<div class="module-box flex-grow">
		<div class="module-bg flex-column" :angle="chart">
			<template v-if="chart">
				<div class="border-top flex">
					<div class="angle"></div>
					<div class="border flex-grow"></div>
					<div class="angle"></div>
				</div>
				<div class="border-sides flex flex-grow">
					<div class="border"></div>
					<div class="center flex-grow"></div>
					<div class="border"></div>
				</div>
				<div class="border-bottom flex">
					<div class="angle"></div>
					<div class="border flex-grow"></div>
					<div class="angle"></div>
				</div>
			</template>
		</div>
		<div class="module flex-column" :style="{'padding-top': title ? 0 : '.2rem'}">
			<div v-if="title" class="title flex-between-center" :style="{'height': `${chart ? 0.5 : 0.65}rem`, 'padding': chart ? '0 .12rem' : 0}">
				<div class="flex-center">
					<img v-if="!chart" src="@/assets/image/digital/title.png" alt="">
					<p>{{title}}</p>
				</div>
				<!-- <span v-if="period" class="period"><i class="tf">&#xe678;</i> 近7天</span> -->
			</div>
			<div class="content flex-grow flex-column"><slot></slot></div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			title: String,
			chart: Boolean
		}
	}
</script>

<style lang="stylus" scoped>
	.module {
		box-sizing: border-box;
		position: relative;
		height: 100%;
		padding: 0 .1rem .1rem;

		&-box {
			position: relative;
		}
		
		&-bg {
			position: absolute;
			left: 0;
			right: 0;
			top: 0;
			bottom: 0;

			&:not([angle]) {
				border: 1px solid rgba(49,198,253,.9);
				border-radius: .08rem;
				background: rgba(11,50,100,.8);
				box-shadow: inset 0 0 .4rem 0 rgba(49,198,253,.3);
			}
			
			.border {
				&-top,
				&-bottom {
					min-height: .4rem;
				}
				
				&-top {
					.angle:nth-last-child(1) {
						transform: rotate(90deg);
					}
					
					.border {
						background-image: url('~@/assets/image/digital/box_border_top.png');
						background-size: 100% 100%;
					}
				}
				
				&-sides {
					.border {
						min-width: .4rem;
						background-size: 100% 100%;
							
						&:nth-child(1) {
							background-image: url('~@/assets/image/digital/box_border_left.png');
						}
						
						&:nth-last-child(1) {
							background-image: url('~@/assets/image/digital/box_border_right.png');
						}
					}
				}
				
				&-bottom {
					.angle {
						&:nth-child(1) {
							transform: rotate(-90deg);
						}
						
						&:nth-last-child(1) {
							transform: rotate(180deg);
						}
					}
					
					.border {
						background-image: url('~@/assets/image/digital/box_border_bottom.png');
						background-size: 100% 100%;
					}
				}
			}
			
			.angle {
				min-width: .4rem;
				background-image: url('~@/assets/image/digital/box_angle.png');
				background-size: 100% 100%;
			}
			
			.center {
				background: rgba(11,49,85,.5);
			}
		}
		
		.title {
			position: relative;
			box-sizing: border-box;

			img {
				width: .12rem;
				margin-right: .16rem;
			}
			
			p {
				font-size: .18rem;
				font-weight: bold;
				color: #46CDFF;
			}

			.period {
				font-size: .14rem;
				color: #F3EB07;

				.tf {
					margin-right: .05rem;
				}
			}
		}
	}
</style>
